import type { HTMLAttributes } from 'react';
import styles from './Card.module.css';

/** Paper card with a chunky outline, used for menus and forms. */
export function Card({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return <section className={[styles.card, className].filter(Boolean).join(' ')} {...props} />;
}
